/**
 * The redline screen's path.
 *
 * Kept inline to this feature rather than added to `components/am-tp-demo/routes.ts`: that file is for paths
 * more than one track needs, and this screen is linked only from this track's own kebab.
 *
 * A demo surface that must not read as one. It sits under `/transfer-pricing/` because the URL is on screen for the
 * whole presentation, and a path naming the demo would tell the client the comparison they are looking at is a
 * mock-up. See the note in `components/am-tp-demo/routes.ts` for the rule this follows.
 */
export const AM_TP_DEMO_AGREEMENT_REDLINE_ROUTE =
  '/transfer-pricing/agreement-redline';
